import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { ApiError } from '../../api/client'
import { usersEventsQuery } from '../../api/settingsUsers'
import { DataTable, useTableState } from '../../ui/DataTable'
import { Forbidden } from '../../ui/Forbidden'
import { eventColumns } from './AccountWorkspace'
import { failed, tableRequest } from './shared'

/**
 * Users Events - `events/index.php`, cu `UserEventsModel`.
 *
 * Aceleasi trei coloane ca jurnalul unui singur cont, si acelasi capat: fara
 * `user_id`, jurnalul e al TUTUROR conturilor (`user_events_data('extract')`).
 */

const ORDER_NAMES = ['event_date', 'event_message', 'user']

export function EventsPanel() {
  const [state, setState] = useTableState('settings-users-events', {
    start: 0,
    length: 25,
    order: { column: 0, dir: 'desc' },
    search: '',
  })
  const columns = useMemo(() => eventColumns(), [])
  const table = useQuery({
    ...usersEventsQuery(tableRequest(state, ORDER_NAMES, 'event_date')),
    placeholderData: keepPreviousData,
  })

  if (table.error instanceof ApiError && table.error.status === 403) return <Forbidden />

  return (
    <div id="content">
      <h4>
        <strong>Users </strong> Events
      </h4>
      <label className="color" style={{ marginBottom: 0 }}>
        View all users events
      </label>
      <hr />

      <DataTable
        id="settings-users-events"
        columns={columns}
        rows={(table.data?.data ?? []) as unknown as Record<string, unknown>[]}
        total={table.data?.recordsFiltered ?? 0}
        fetching={table.isFetching}
        error={table.error ? failed(table.error) : null}
        onRetry={() => void table.refetch()}
        state={state}
        onState={setState}
        rowId={(row) => `rowd_${Number(row.id)}`}
        emptyHint="Nothing has happened on any account yet."
      />
    </div>
  )
}
